import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "copy",
  "use": "copy-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"copy\"><g stroke=\"#000\" fill=\"none\" fill-rule=\"evenodd\"><path d=\"M11.108 14.552l-.01.01-3.476 3.474a3.883 3.883 0 01-5.487 0 3.883 3.883 0 010-5.486l3.658-3.658a3.88 3.88 0 015.269-.207\" /><path d=\"M8.89 5.79l.011-.01 3.477-3.474a3.883 3.883 0 015.486 0 3.883 3.883 0 010 5.486l-3.657 3.658a3.88 3.88 0 01-5.27.207\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol